export const SESSION_STORAGE_KEYS = {
    TOGGLED: 'requestsCounterToggled',
    ONLY_REPEATED_CALLS: 'requestsCounterOnlyRepeatedCalls',
    FILTER_TYPE: 'requestsCounterFilterType',
    SEARCH_FOR: 'requestsCounterSearchFor',
};
